export const breadcrumbPathStartPartLength = 1;
export const breadcrumbPathEndPartLength = 2;
